import get from 'lodash/get';

export const selectPartyClient = (state) => get(state, 'party.selectedClient') || {};
